import { render, staticRenderFns } from "./Course.vue?vue&type=template&id=130a0eb5&"
import script from "./Course.vue?vue&type=script&lang=ts&"
export * from "./Course.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports